const navigationMap = {
  introduction: {
    curr: "Introduction",
    nextLink: "/docs/getting-started/interface-overview",
    nextText: "Interface Overview",
  },
  "interface-overview": {
    curr: "Interface Overview",
    prevLink: "/docs/getting-started/introduction",
    prevText: "Introduction",
    nextLink: "/docs/integrations/integration-overview",
    nextText: "Integration Overview",
  },
  "integration-overview": {
    curr: "Integration Overview",
    prevLink: "/docs/getting-started/introduction",
    prevText: "Interface Overview",
    nextLink: "/docs/integrations/github-integration",
    nextText: "Github Integration",
  },
  "github-integration": {
    curr: "Github Integration",
    prevLink: "/docs/integrations/integration-overview",
    prevText: "Integration Overview",
    nextLink: "/docs/integrations/jira-integration",
    nextText: "Jira Integration",
  },
  "jira-integration": {
    curr: "Jira Integration",
    prevLink: "/docs/integrations/github-integration",
    prevText: "Github Integration",
    nextLink: "/docs/integrations/asana-integration",
    nextText: "Asana Integration",
  },
  "asana-integration": {
    curr: "Asana Integration",
    prevLink: "/docs/integrations/jira-integration",
    prevText: "Jira Integration",
    nextLink: "/docs/integrations/trello-integration",
    nextText: "Trello Integration",
  },
  "trello-integration": {
    curr: "Trello Integration",
    prevLink: "/docs/integrations/asana-integration",
    prevText: "Asana Integration",
    nextLink: "/docs/cicd/cicd-automation",
    nextText: "CI/CD Automation",
  },
  "cicd-automation": {
    curr: "CI/CD Automation",
    prevLink: "/docs/integrations/trello-integration",
    prevText: "Trello Integration",
    nextLink: "/docs/cicd/integrating-jenkins",
    nextText: "Integrating jenkins",
  },
  "integrating-jenkins": {
    curr: "Integrating Jenkins",
    prevLink: "/docs/cicd/cicd-automation",
    prevText: "CI/CD Automation",
    nextLink: "/docs/cicd/integrating-circleci",
    nextText: "Integrating CircleCI",
  },
  "integrating-circleci": {
    curr: "Integrating CircleCI",
    prevLink: "/docs/cicd/integrating-jenkins",
    prevText: "Integrating Jenkins",
    nextLink: "/docs/cicd/integrating-bitbucket",
    nextText: "Integrating BitBucket",
  },
  "integrating-bitbucket": {
    curr: "Integrating BitBucket",
    prevLink: "/docs/cicd/integrating-circleci",
    prevText: "Integrating CircleCI",
    nextLink: "/docs/cicd/integrating-travisci",
    nextText: "Integrating Travis CI",
  },
  "integrating-travisci": {
    curr: "Integrating TravisCI",
    prevLink: "/docs/cicd/integrating-bitbucket",
    prevText: "Integrating BitBucket",
    nextLink: "/apis/api-overview",
    nextText: "APIs Overview",
  },
  "api-overview": {
    curr: "APIs Overview",
    prevLink: "/docs/cicd/integrating-travisci",
    prevText: "Integrating Travis CI",
    nextLink: "/apis/auth-using-api",
    nextText: "API Authentication",
  },
  "auth-using-api": {
    curr: "API Authentication",
    prevLink: "/apis/api-overview",
    prevText: "APIs Overview",
    nextLink: "/apis/project-management",
    nextText: "Project Management API",
  },
  "project-management": {
    curr: "Project Management API",
    prevLink: "/apis/auth-using-api",
    prevText: "API Authentication",
    nextLink: "/apis/managing-test-suites",
    nextText: "Managing Test Cases",
  },
  "managing-test-suites": {
    curr: "Managing Test Cases",
    prevLink: "/apis/project-management",
    prevText: "Project Management API ",
    nextLink: "/apis/test-run",
    nextText: "Test Run API",
  },
  "test-run": {
    curr: "Test Run API",
    prevLink: "/apis/managing-test-suites",
    prevText: "Managing Cases",
    nextLink: "/apis/update-test-case",
    nextText: "Update Test Case Status",
  },
  "update-test-case": {
    curr: "Update Test Case Status",
    prevLink: "/apis/test-run",
    prevText: "Test Run API",
    nextLink: "/apis/error-handling",
    nextText: "Error Handling",
  },
  "error-handling": {
    curr: "Error Handling",
    prevLink: "/apis/update-test-case",
    prevText: "Update Test Case Status",
    nextLink: "/docs/generate-ai/getting-started-with-ai",
    nextText: "Generating Test Plan",
  },
  "getting-started-with-ai": {
    curr: "Generating Test Plan",
    prevLink: "/apis/error handling",
    prevText: "Error Handling",
    nextLink: "/docs/generate-ai/ai-suggest",
    nextText: "Suggestion from AI",
  },
  "ai-automation": {
    curr: "AI Automation",
    prevLink: "/docs/generate-ai/ai-suggest",
    prevText: "Suggestion from AI",
    nextLink: "/docs/test-plans/test-plan",
    nextText: "Managing Test Plans",
  },
  "ai-suggest": {
    curr: "Suggestion from AI",
    prevLink: "/getting-started-with-ai/error handling",
    prevText: "Generating Test Plan",
    nextLink: "/docs/automation/ai-automation",
    nextText: "AI Automation",
  },
  "test-plan": {
    curr: "Managing Test Plans",
    prevLink: "/docs/getting-started/interface-overview",
    prevText: "Interface Overview",
    nextLink: "/docs/test-plans/importing-test-cases",
    nextText: "Importing Test Cases",
  },
  "importing-test-cases": {
    curr: "Importing Test Cases",
    prevLink: "/docs/test-plans/test-plan",
    prevText: "Managing Test Plans",
    nextLink: "/docs/executing-test-runs/customize-test-runs",
    nextText: "Create Test Runs",
  },
  "customize-test-runs": {
    curr: "Create Test Runs",
    prevLink: "/docs/test-plans/importing-test-cases",
    prevText: "Importing Test Cases",
    nextLink: "/docs/executing-test-runs/updating-test-runs",
    nextText: "Updating Test Run",
  },
  "updating-test-runs": {
    curr: "Updating Test Run",
    prevLink: "/docs/executing-test-runs/customize-test-runs",
    prevText: "Create Test Runs",
    nextLink: "/docs/executing-test-runs/assigning-test-cases",
    nextText: "Assign Test Cases",
  },
  "assigning-test-cases": {
    curr: "Assign Test Cases",
    prevLink: "/docs/executing-test-runs/updating-test-runs",
    prevText: "Updating Test Run",
    nextLink: "/docs/test-results-and-analytics/reviewing-test-results",
    nextText: "Reviewing test results",
  },
  "reviewing-test-results": {
    curr: "Reviewing test results",
    prevLink: "/docs/executing-test-runs/assigning-test-cases",
    prevText: "Assign Test Cases",
    nextLink: "/docs/test-results-and-analytics/analyzing-test-analytics",
    nextText: "Analyzing Test Analytics",
  },
  "analyzing-test-analytics": {
    curr: "Analyzing Test Analytics",
    prevLink: "/docs/test-results-and-analytics/reviewing-test-results",
    prevText: "Reviewing test results",
    nextLink: "/docs/sharing-test-plans/sharing-test-plans",
    nextText: "Sharing Test plans",
  },
  "sharing-test-plans": {
    curr: "Sharing Test plans",
    prevLink: "/docs/test-results-and-analytics/analyzing-test-analytics",
    prevText: "Analyzing Test Analytics",
    nextLink: "/docs/sharing-test-plans/merging-projects",
    nextText: "Merging Projects",
  },
  "merging-projects": {
    curr: "Merging Projects",
    prevLink: "/docs/sharing-test-plans/sharing-test-plans",
    prevText: "Sharing Test plans",
    nextLink: "/docs/sharing-test-plans/inviting-team-members",
    nextText: "Inviting Team Members",
  },
  "inviting-team-members": {
    curr: "Inviting Team Members",
    prevLink: "/docs/sharing-test-plans/merging-projects",
    prevText: "Merging Projects",
    nextLink: "/docs/project-settings/project-settings",
    nextText: "Project Settings",
  },
  "project-settings": {
    curr: "Project Settings",
    prevLink: "/docs/sharing-test-plans/inviting-team-members",
    prevText: "Inviting Team Members",
  },
};
export default navigationMap;
